import { useDispatch } from 'react-redux';
import { useHomeSlice } from 'app/pages/Home/slice';
import { type UserPreferences } from 'utils/helpers';

/**
 * Custom hook to restore Must Win dropdown state from localStorage
 *
 * This hook provides a function that:
 * - Restores the blue highlight on the Must Win dropdown item
 * - Restores the hide empty swimlanes setting
 * - Used during app initialization to restore user's previous state
 *
 * Usage:
 * ```typescript
 * const restoreMustWinState = useRestoreMustWinState();
 *
 * // In restoration logic:
 * const preferences = getUserPreferences();
 * restoreMustWinState(preferences);
 * ```
 *
 * @returns A function that restores Must Win dropdown state from preferences
 */
export function useRestoreMustWinState() {
  const { actions } = useHomeSlice();
  const dispatch = useDispatch();

  const restoreMustWinState = (preferences: UserPreferences) => {
    if (preferences.hideEmptySwimLanes !== undefined) {
      dispatch(actions.setHideEmptySwimLanes(preferences.hideEmptySwimLanes));
    }
    if (preferences.mustWinDropdownSelection !== undefined) {
      dispatch(
        actions.setMustWinDropdownSelection(
          preferences.mustWinDropdownSelection
        )
      );
    }
  };

  return restoreMustWinState;
}
